module.exports = __webpack_public_path__ + "img/na.76be167c.svg";